import type { BankInfo } from "./bank.js";

export const bankCodesBySwiftCode = {
  AASQPHM1: {
    name: "AAA SOUTHEAST EQUITIES INC.",
    city: "CITY OF MAKATI",
  },
  ABAEPHM1: {
    name: "ABACUS SECURITIES CORP.",
    city: "CITY OF PASIG",
  },
  ABTZPH21: {
    name: "ABOITIZ EQUITY VENTURES INC.",
    city: "CITY OF CEBU",
  },
  ACICPHM1: {
    name: "ABACUS CAPITAL AND INVESTMENT CORPORATION",
    city: "CITY OF PASIG",
  },
  ACKEPHM1: {
    name: "I. ACKERMAN AND CO INC",
    city: "CITY OF MAKATI",
  },
  AGBUPHM1: {
    name: "AGRIBUSINESS RURAL BANK, INC.",
    city: "CITY OF PASIG",
  },
  AIACPHM1GIO: {
    name: "AIA PHILIPPINES",
    city: "CITY OF TAGUIG",
    branch: "GENERAL INVESTMENT OPERATIONS",
  },
  AIACPHMM: {
    name: "AIA PHILIPPINES",
    city: "CITY OF MAKATI",
  },
  AIIPPHM1: {
    name: "AL-AMANAH ISLAMIC INVESTMENT BANK OF THE PHILIPPINES",
    city: "CITY OF MAKATI",
  },
  AIIPPHMM: {
    name: "AL-AMANAH ISLAMIC INVESTMENT BANK OF THE PHILIPPINES",
    city: "CITY OF MAKATI",
  },
  ALKBPHM2: {
    name: "ALLBANK (A THRIFT BANK) INC",
    city: "CITY OF MANDALUYONG",
  },
  ALPCPHM1: {
    name: "ALPHA SECURITIES CORP.",
    city: "CITY OF MAKATI",
  },
  ALSGPHM1: {
    name: "ALLIED SAVINGS BANK",
    city: "CITY OF MAKATI",
  },
  AMONPHM1: {
    name: "AMON SECURITIES CORP.",
    city: "CITY OF MAKATI",
  },
  ANGPPHM1: {
    name: "ANGPING AND ASSO. SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  ANSCPHM1: {
    name: "AB CAPITAL SECURITIES INC.",
    city: "CITY OF TAGUIG",
  },
  ANSGPHM1: {
    name: "ANSALDO, GODINEZ AND COMPANY, INC.",
    city: "CITY OF MANILA",
  },
  ANZBPHMX: {
    name: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED",
    city: "CITY OF MAKATI",
  },
  APCEPHM1: {
    name: "ASIA PACIFIC CAPITAL EQUITIES AND SEC. CORP.",
    city: "CITY OF QUEZON",
  },
  APHIPHM2: {
    name: "ALIPAY PHILIPPINES INC.",
    city: "CITY OF TAGUIG",
  },
  APHIPHM3: {
    name: "ALIPAY PHILIPPINES INC.",
    city: "CITY OF TAGUIG",
  },
  ARMEPHM1: {
    name: "ARMSTRONG SECURITIES INC.",
    city: "CITY OF PASIG",
  },
  ASDBPHMM: {
    name: "ASIAN DEVELOPMENT BANK",
    city: "CITY OF MANDALUYONG",
  },
  ASDVPHM1: {
    name: "NEXTGENESIS CORPORATION",
    city: "CITY OF QUEZON",
  },
  ASESPHM1: {
    name: "ASIASEC EQUITIES INC.",
    city: "CITY OF MANILA",
  },
  ASIIPHM1: {
    name: "D'ASIAN HILLS BANK INC.",
    city: "CITY OF MALAYBALAY",
  },
  ASISPHM1: {
    name: "ASI SECURITIES INC.",
    city: "CITY OF MAKATI",
  },
  ASTSPHM1: {
    name: "ASTRA SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  ATCSPHM1: {
    name: "ATC SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  ATDBPHM1: {
    name: "ASIATRUST BANK",
    city: "CITY OF QUEZON",
  },
  ATDBPHM10M2: {
    name: "ASIATRUST BANK",
    city: "CITY OF ANTIPOLO",
  },
  ATDBPHM10M3: {
    name: "ASIATRUST BANK",
    city: "CITY OF BACOOR",
  },
  ATDBPHM10M4: {
    name: "ASIATRUST BANK",
    city: "CITY OF CALOOCAN",
  },
  ATDBPHM10M5: {
    name: "ASIATRUST BANK",
    city: "CITY OF ANTIPOLO",
    branch: "MASINAG BRANCH",
  },
  ATDBPHM10M6: {
    name: "ASIATRUST BANK",
    city: "CITY OF QUEZON",
    branch: "NEW MANILA BRANCH",
  },
  ATDBPHM10M7: {
    name: "ASIATRUST BANK",
    city: "CITY OF PASAY",
  },
  ATDBPHM10M8: {
    name: "ASIATRUST BANK",
    city: "CITY OF QUEZON",
    branch: "DEL MONTE BRANCH",
  },
  ATDBPHM10MA: {
    name: "ASIATRUST BANK",
    city: "CITY OF QUEZON",
    branch: "ROOSEVELT BRANCH",
  },
  ATDBPHM10MB: {
    name: "ASIATRUST BANK",
    city: "CITY OF MANILA",
    branch: "SALCEDO BRANCH",
  },
  ATDBPHM10MC: {
    name: "ASIATRUST BANK",
    city: "CITY OF SAN JUAN",
  },
  ATDBPHM10MD: {
    name: "ASIATRUST BANK",
    city: "CITY OF TUGUEGARAO",
  },
  ATDBPHM10ME: {
    name: "ASIATRUST BANK",
    city: "CITY OF MANILA",
    branch: "TUTUBAN CENTERMALL BRANCH",
  },
  ATDBPHM10MF: {
    name: "ASIATRUST BANK",
    city: "CITY OF VALENZUELA",
  },
  ATDBPHM10MM: {
    name: "ASIATRUST BANK",
    city: "CITY OF MANILA",
    branch: "PASONG TAMO BRANCH",
  },
  ATSCPHM1: {
    name: "MAYBANK ATR KIM ENG SECURITIES, INC.",
    city: "CITY OF MAKATI",
  },
  AUBKPHMM: {
    name: "ASIA UNITED BANK CORPORATION",
    city: "CITY OF PASIG",
  },
  AURSPHM1: {
    name: "AURORA SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  AYCOPHMM: {
    name: "AYALA CORPORATION",
    city: "CITY OF MAKATI",
  },
  BADGPHM1: {
    name: "BANCODIPOLOG, INC.",
    city: "CITY OF DIPOLOG",
  },
  BARNPHM1: {
    name: "J.M. BARCELON AND CO INC",
    city: "CITY OF MANILA",
  },
  BATSPHM1: {
    name: "BRITISH AMERICAN TOBACCO PHILIPPINES LTD.",
    city: "CITY OF MUNTINLUPA",
  },
  BATTPHM1: {
    name: "B A SECURITIES INC",
    city: "CITY OF MANILA",
  },
  BBOAPHM1: {
    name: "BSP BRANCH OPEN ACCOUNT SPC",
    city: "CITY OF QUEZON",
  },
  BDESPHM1: {
    name: "BDO ELITE SAVINGS BANK, INC.",
    city: "CITY OF TAGUIG",
  },
  BDSCPHM1: {
    name: "BDO SECURITIES CORPORATION",
    city: "CITY OF MAKATI",
  },
  BELCPHM1: {
    name: "BELSON SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  BENCPHM1: {
    name: "H.E. BENNETT SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  BENJPHM1: {
    name: "BENJAMIN CO CA AND CO INC.",
    city: "CITY OF MANILA",
  },
  BEREPHM1: {
    name: "BERNAD SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  BFSCPHM1: {
    name: "BFE FINANCIAL SVCS. AND CONSULTANCY, INC.",
    city: "CITY OF MAKATI",
  },
  BFSRPHM2: {
    name: "BANANA FINTECH SERVICES CORPORATION",
    city: "CITY OF MAKATI",
  },
  BHCHPHM1: {
    name: "B. H. CHUA SECURITIES CORPORATION",
    city: "CITY OF MANILA",
  },
  BHFUPHM1: {
    name: "PROVIDENT FUND OFFICE (BSP-PFO)",
    city: "CITY OF MANILA",
  },
  BIURPHM2: {
    name: "BINAN RURAL BANK, INC.",
    city: "CITY OF BINAN",
  },
  BIUUPHM1: {
    name: "BINANGONAN RURAL BANK, INC",
    city: "CITY OF ANTIPOLO",
  },
  BKCHPHMM: {
    name: "BANK OF CHINA (HONG KONG) LIMITED - MANILA BRANCH",
    city: "CITY OF TAGUIG",
  },
  BKCHPHMMRTS: {
    name: "BANK OF CHINA (HONG KONG) LIMITED - MANILA BRANCH",
    city: "TAGUIG CITY",
    branch: "BANK OF CHINA LIMITED MANILA BRANCH RMB CLEARING CENTER",
  },
  BKKBPHMM: {
    name: "BANGKOK BANK PUBLIC COMPANY LIMITED, MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  BKRUPHM1: {
    name: "BANCO BAKUN, INC. (A RURAL BANK)",
    city: "CITY OF BAGUIO",
  },
  BNNNPH22: {
    name: "BANCNET, INC.",
    city: "CITY OF MAKATI",
  },
  BNNNPHM2: {
    name: "BANCNET, INC.",
    city: "CITY OF MAKATI",
  },
  BNORPHMM: {
    name: "BDO UNIBANK, INC.",
    city: "CITY OF MAKATI",
  },
  BNPAPHMM: {
    name: "BNP PARIBAS, MANILA OFFSHORE BRANCH",
    city: "CITY OF MAKATI",
  },
  BOFAPH2X: {
    name: "BANK OF AMERICA, N.A. MANILA",
    city: "CITY OF MAKATI",
  },
  BOPBPHMM: {
    name: "BDO PRIVATE BANK INC.",
    city: "CITY OF MAKATI",
  },
  BOPIPHMM: {
    name: "BANK OF THE PHILIPPINE ISLANDS",
    city: "CITY OF MAKATI",
  },
  BOPIPHMMTRY: {
    name: "BANK OF THE PHILIPPINE ISLANDS",
    city: "CITY OF MAKATI",
    branch: "TREASURY GROUP",
  },
  BORRPHM1: {
    name: "BOF, INC. (A RURAL BANK)",
    city: "CITY OF SAN FERNANDO",
  },
  BOTKPHMM: {
    name: "MUFG BANK, LTD., MANILA BRANCH",
    city: "CITY OF MAKATI",
    branch: "MANILA BRANCH",
  },
  BPCNPHM1: {
    name: "BPI CARD FINANCE",
    city: "CITY OF MAKATI",
  },
  BPDIPHM1: {
    name: "BPI DIRECT",
    city: "CITY OF MAKATI",
  },
  BPFFPHM1: {
    name: "BPI FAMILY BANK",
    city: "CITY OF MANILA",
  },
  BPFSPHM1: {
    name: "BPI FAMILY SAVINGS BANK",
    city: "CITY OF MAKATI",
  },
  BPGOPHM1: {
    name: "BPI GLOBE BANKO INC.",
    city: "CITY OF MAKATI",
  },
  BPISPHM1: {
    name: "BPI SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  BPLIPHM1: {
    name: "BPI LEASING CORPORATION",
    city: "CITY OF MANILA",
  },
  BPPSPHM1: {
    name: "BNP PARIBAS PEREGRINE SECURITIES, INC",
    city: "CITY OF MAKATI",
  },
  BPRFPHM1: {
    name: "BSP PROVIDENT FUND",
    city: "CITY OF MANILA",
  },
  BROXPHM1: {
    name: "BARCELON ROXAS SECURITIES INC.",
    city: "CITY OF MAKATI",
  },
  BRULPHM1: {
    name: "BALANGA RURAL BANK, INC.",
    city: "CITY OF BALANGA",
  },
  BUTRPHM1: {
    name: "BUREAU OF THE TREASURY",
    city: "CITY OF MANILA",
  },
  CALAPHM1: {
    name: "CAMPOS, LANUZA AND CO. INC.",
    city: "CITY OF PASIG",
  },
  CALAPHM10M2: {
    name: "CAMPOS, LANUZA AND CO. INC.",
    city: "CITY OF MAKATI",
  },
  CAMZPHM2: {
    name: "CARD MRI RIZAL BANK, INC.",
    city: "SANTA CRUZ",
  },
  CASUPHM1: {
    name: "A.T. DE CASTRO SECURITIES CORPORATION",
    city: "CITY OF MANILA",
  },
  CAVPPHM1: {
    name: "AB CAPITAL AND INVESTMENT CORPORATION",
    city: "CITY OF MAKATI",
  },
  CBMFPHM1: {
    name: "CARD BANK, INC. (A MICROFINANCE ORIENTED RURAL BANK)",
    city: "CITY OF SAN PABLO",
  },
  CBSLPHM1: {
    name: "COMMONWEALTH BANK/SAVINGS AND LOAN",
    city: "CITY OF MANDALUYONG",
  },
  CCBCPHMM: {
    name: "CHANG HWA COMMERCIAL BANK,LTD. MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  CELRPHM1: {
    name: "CEBUANA LHUILLIER RURAL BANK INC.",
    city: "CITY OF BACOOR",
  },
  CENEPHM1: {
    name: "CENTURY SECURITIES CORP.",
    city: "CITY OF QUEZON",
  },
  CESNPHM1: {
    name: "CENTURY SAVINGS BANK CORPORATION",
    city: "CITY OF PASIG",
  },
  CFGOPHM1: {
    name: "COL FINANCIAL GROUP, INC.",
    city: "CITY OF PASIG",
  },
  CHASPHMM: {
    name: "JPMORGAN CHASE BANK, N.A., MANILA BRANCH",
    city: "CITY OF TAGUIG",
  },
  CHASPHMMENQ: {
    name: "JPMORGAN CHASE BANK, N.A., MANILA BRANCH",
    city: "CITY OF MANILA",
    branch: "TELEX AND S.W.I.F.T. MESSAGE ENQUIRIES",
  },
  CHASPHMMOBU: {
    name: "JPMORGAN CHASE BANK, N.A., MANILA BRANCH",
    city: "CITY OF MAKATI",
    branch: "OFFHORE BANKING UNIT",
  },
  CHASPHS1: {
    name: "J.P. MORGAN SECURITIES PHILIPPINES INC.",
    city: "CITY OF MAKATI",
  },
  CHBKPHMM: {
    name: "CHINA BANKING CORPORATION",
    city: "CITY OF MAKATI",
  },
  CHCSPHM1: {
    name: "E. CHUA CHIACO SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  CHSVPHM1: {
    name: "CHINA BANK SAVINGS, INC.",
    city: "CITY OF MAKATI",
  },
  CIPHPHM1: {
    name: "CIMB BANK PHILIPPINES INC.",
    city: "CITY OF TAGUIG",
  },
  CIPHPHMM: {
    name: "CIMB BANK PHILIPPINES INC.",
    city: "CITY OF TAGUIG",
  },
  CITIPH21: {
    name: "CITIBANK SAVINGS INC.",
    city: "CITY OF QUEZON",
  },
  CITIPHMX: {
    name: "CITIBANK,N.A., MANILA BRANCH",
    city: "CITY OF TAGUIG",
    branch: "HEAD OFFICE",
  },
  CITIPHMXCBU: {
    name: "CITIBANK,N.A., MANILA BRANCH",
    city: "CITY OF CEBU",
  },
  CITIPHMXTSU: {
    name: "CITIBANK,N.A., MANILA BRANCH",
    city: "CITY OF MANILA",
    branch: "IBG-TREASURY SERVICES UNIT",
  },
  CITRPHM1: {
    name: "CITYTRUST SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  CITSPHM1: {
    name: "CITISECURITIES INC.",
    city: "CITY OF PASIG",
  },
  CIVAPHM1: {
    name: "CITY SAVINGS BANK",
    city: "CITY OF CEBU",
  },
  CIVVPHM1: {
    name: "CITYSTATE SAVINGS BANK, INC.",
    city: "CITY OF PASIG",
  },
  CIYCPHM2: {
    name: "CIS BAYAD CENTER, INC.",
    city: "CITY OF PASIG",
  },
  CLRAPH21: {
    name: "CLASSIC RURAL BANK, INC.",
    city: "CITY OF BATANGAS",
  },
  CLSAPHM1: {
    name: "CLSA PHILIPPINES, INC.",
    city: "CITY OF MAKATI",
  },
  CNRLPHM1: {
    name: "CANTILAN BANK, INC. (A RURAL BANK)",
    city: "CITY OF BISLIG",
  },
  COBMPHM1: {
    name: "BANK OF COMMERCE",
    city: "CITY OF MAKATI",
  },
  COUKPHM1: {
    name: "COUNTRY BUILDERS BANK INC. (A RURAL BANK)",
    city: "CITY OF TAGUIG",
  },
  COYAPHM2: {
    name: "COOPERATIVE BANK OF CAGAYAN",
    city: "CITY OF TUGUEGARAO",
  },
  COYIPHM1: {
    name: "COYIUTO SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  CPBBPHM1: {
    name: "UCPB SECURITIES INC.",
    city: "CITY OF MAKATI",
  },
  CPBOPHM1: {
    name: "COOPERATIVE BANK OF BOHOL",
    city: "CITY OF TAGBILARAN",
  },
  CPCTPHM1: {
    name: "COOPERATIVE BANK OF COTABATO",
    city: "CITY OF KIDAPAWAN",
  },
  CPHIPHMM: {
    name: "PHILIPPINE BANK OF COMMUNICATIONS",
    city: "CITY OF MAKATI",
  },
  CRESPHM1: {
    name: "CREDIT SUISSE SECURITIES (PHILIPPINES) INC.",
    city: "CITY OF MAKATI",
  },
  CRMHPHM1: {
    name: "CARD SME BANK, INC. A THRIFT BANK",
    city: "CITY OF SANTO TOMAS",
  },
  CRSEPHM1: {
    name: "CROSBY SECURITIES (PHILS) INC.",
    city: "CITY OF MAKATI",
  },
  CTCBPHMM: {
    name: "CTBC BANK (PHILIPPINES) CORP.",
    city: "CITY OF TAGUIG",
  },
  CUASPHM1: {
    name: "CUALOPING SECURITIES CORP",
    city: "CITY OF MANILA",
  },
  CUATPHM1: {
    name: "MINDANAO CONSOLIDATED COOPERATIVE BANK",
    city: "CITY OF CAGAYAN DE ORO",
  },
  CUOBPHM2: {
    name: "COMMUNITY RURAL BANK OF ROMBLON (ROMBLON), INC",
    city: "CITY OF ROMBLON",
  },
  DANIPHM1: {
    name: "PT BANK DAGANG NASIONAL INDONESIA",
    city: "CITY OF MANILA",
  },
  DAVSPHM1: {
    name: "DAVID GO SECURITIES CORP",
    city: "CITY OF MANILA",
  },
  DBPHPHMM: {
    name: "DEVELOPMENT BANK OF THE PHILIPPINES",
    city: "CITY OF MAKATI",
  },
  DBSHPHM1: {
    name: "DBP-DAIWA CAPITAL MARKETS PHILIPPINES, INC.",
    city: "CITY OF MAKATI",
  },
  DBSPPHM1: {
    name: "DBS SECURITIES (PHILS) INC",
    city: "CITY OF MAKATI",
  },
  DCDEPHM1: {
    name: "DUMAGUETE CITY DEVELOPMENT BANK,INC",
    city: "CITY OF DUMAGUETE",
  },
  DCPHPHM1: {
    name: "DCPAY PHILIPPINES, INC",
    city: "CITY OF PASIG",
  },
  DEUTPHMM: {
    name: "DEUTSCHE BANK AG",
    city: "CITY OF MANILA",
  },
  DHBIPHM1: {
    name: "BDO UNIBANK, INC.",
    city: "CITY OF MANILA",
  },
  DHSPPHM1: {
    name: "DHARMALA INTL. PHILS. INC.",
    city: "CITY OF MAKATI",
  },
  DIVSPHM1: {
    name: "DIVERSIFIED SECURITIES INC",
    city: "CITY OF MANILA",
  },
  DSPHPHM1: {
    name: "DBP-DAIWA CAPITAL MARKETS PHILIPPINES, INC.",
    city: "CITY OF MANILA",
  },
  DUMTPHM1: {
    name: "DUNGGANON BANK (A MICROFINANCE RURAL BANK) INC",
    city: "CITY OF BACOLO",
  },
  EAGMPHM2: {
    name: "EASYPAY GLOBAL EMI CORP.",
    city: "CITY OF TAGUIG",
  },
  EASDPHM1: {
    name: "EASTERN SECURITIES DEVELOPMENT CORPORATION",
    city: "CITY OF MANILA",
  },
  EAWCPHM1: {
    name: "EAST WEST CAPITAL CORP",
    city: "CITY OF MANILA",
  },
  EAWRPHM2: {
    name: "EAST WEST RURAL BANK, INC.",
    city: "CITY OF DAVAO",
  },
  ECASPHM2: {
    name: "ECASHPAY ASIA INC",
    city: "CITY OF QUEZON",
  },
  EISEPHM1: {
    name: "EIB SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  ENRUPHM1: {
    name: "ENTREPRENEUR RURAL BANK, INC.",
    city: "CITY OF SAN PEDRO",
  },
  ENTHPHM1: {
    name: "ENTERPRISE BANK INC. (A THRIFT BANK)",
    city: "CITY OF LIANGA",
  },
  EQICPHM1: {
    name: "SB EQUITIES INCORPORATED",
    city: "CITY OF MAKATI",
  },
  EQSNPHM1: {
    name: "EQUICOM SAVINGS BANK, INC.",
    city: "CITY OF MAKATI",
  },
  EQSPPHM1: {
    name: "EQUITABLE SECURITIES (PHILS.) INC.",
    city: "CITY OF MANILA",
  },
  EQUSPHM1: {
    name: "EQUITIWORLD SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  ESBEPHM1: {
    name: "EVERGREEN STOCK BROKERAGE AND SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  EWBCPHMM: {
    name: "EAST WEST BANKING CORPORATION",
    city: "CITY OF MAKATI",
  },
  FCBKPHMM: {
    name: "FIRST COMMERCIAL BANK, LTD., MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  FICEPHM1: {
    name: "FIRST INTEGRATED CAPITAL SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  FINUPHM1: {
    name: "FINVEST SECURITIES CO INC",
    city: "CITY OF MANILA",
  },
  FIOOPHM1: {
    name: "FIRST CONSOLIDATED BANK INC.",
    city: "CITY OF TAGBILARAN",
  },
  FIOSPHM1: {
    name: "FIRST ORIENT SECURITIES INC",
    city: "CITY OF MAKATI",
  },
  FIRRPHM1: {
    name: "FIRST RESSOURCES MANAGEMENT AND SECURITIES CORPORATION,THE",
    city: "CITY OF MANILA",
  },
  FMICPHM1: {
    name: "FIRST METRO INVESTMENT CORPORATION",
    city: "CITY OF MANILA",
  },
  FMSOPHM1: {
    name: "FIRST METRO SECURITIES BROKERAGE CORPORATION",
    city: "CITY OF MAKATI",
  },
  FOTRPHM1: {
    name: "FORTUNE SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  FRARPHM1: {
    name: "FIRST AGRO-INDUSTRIAL RURAL BANK, INC. (FAIRBANK)",
    city: "CITY OF BOGO",
  },
  FROEPHM1: {
    name: "FRANCISCO ORTIGAS SECURITIES INC",
    city: "CITY OF MANILA",
  },
  FRUNPHM1: {
    name: "FILIDIAN RURAL BANK OF ANTIPOLO,INC",
    city: "CITY OF ANTIPOLO",
  },
  GARKPHM1: {
    name: "GATEWAY RURAL BANK, INC. (GATEBANK)",
    city: "CITY OF MALOLOS",
  },
  GEGSPHM1: {
    name: "GENESIS GLOBAL SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  GEMPPH21: {
    name: "GE MONEY BANK, INC. (A SAVINGS BANK)",
    city: "CITY OF QUEZON",
  },
  GIMSPHM1: {
    name: "I.B. GIMENEZ SECURITIES, INC.",
    city: "CITY OF PASIG",
  },
  GKGSPHM1: {
    name: "G.K. GOH SECURITIES (PHILIPPINES) INC.",
    city: "CITY OF MAKATI",
  },
  GLSTPHM1: {
    name: "GLOBALINKS SECURITIES AND STOCKS, INC",
    city: "CITY OF MANILA",
  },
  GLTEPHMT: {
    name: "GLOBE TELECOM, INC.",
    city: "CITY OF TAGUIG",
  },
  GOLCPHM1: {
    name: "GOLDSTAR SECURITIES INC",
    city: "CITY OF PASIG",
  },
  GOTYPHM2: {
    name: "GOTYME BANK CORPORATION",
    city: "CITY OF PASIG",
  },
  GPNEPHM2: {
    name: "GPAY NETWORK PH, INC.",
    city: "CITY OF PASIG",
  },
  GRBUPHM1: {
    name: "GUAGUA RURAL BANK, INC.",
    city: "CITY OF ANGELES",
  },
  GSFAPHM1: {
    name: "GSIS FAMILY BANK",
    city: "CITY OF PASIG",
  },
  GUISPHM1: {
    name: "GUILD SECURITIES INC",
    city: "CITY OF MAKATI",
  },
  GUSPPHM1: {
    name: "GUOCO SECURITIES (PHILS) INC",
    city: "CITY OF MAKATI",
  },
  GXCHPHM2: {
    name: "G-XCHANGE, INC.",
    city: "CITY OF TAGUIG",
  },
  HBPHPHMM: {
    name: "HSBC SAVINGS BANK (PHILIPINES) INC.",
    city: "CITY OF MUNTINLUPA",
  },
  HDISPHM1: {
    name: "HDI SECURITIES INC",
    city: "CITY OF MAKATI",
  },
  HENEPHM1: {
    name: "YU HENG SECURITIES INC.",
    city: "CITY OF PASAY",
  },
  HISHPHM1: {
    name: "HIGHLAND SECURITIES PHILS. INC.",
    city: "CITY OF MANILA",
  },
  HIYCPHM1: {
    name: "HIYAS BANKING CORPORATION",
    city: "CITY OF SAN JOSE DEL MONTE",
  },
  HNBKPHMM: {
    name: "HUA NAN COMMERCIAL BANK, LTD. MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  HSBCPHMM: {
    name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD - PHILIPPINE BRANCH",
    city: "CITY OF TAGUIG",
  },
  HSBCPHMMCEB: {
    name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD - PHILIPPINE BRANCH",
    city: "CITY OF CEBU",
    branch: "CEBU BRANCH",
  },
  HSBCPHMMSEC: {
    name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD - PHILIPPINE BRANCH",
    city: "CITY OF PASIG",
    branch: "CUSTODY AND CLEARING",
  },
  HSBCPHMMTRY: {
    name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD - PHILIPPINE BRANCH",
    city: "CITY OF MANILA",
    branch: "MNL TREASURY DEPARTMENT",
  },
  IBKOPHMM: {
    name: "INDUSTRIAL BANK OF KOREA, MANILA BRANCH",
    city: "CITY OF TAGUIG",
  },
  ICBCPHMM: {
    name: "MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD., MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  ICBKPHMM: {
    name: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED, MANILA BRANCH",
    city: "CITY OF TAGUIG",
  },
  IFIPPHM2: {
    name: "INFOSERVE INCORPORATED",
    city: "CITY OF MAKATI",
  },
  IGCSPHM1: {
    name: "IGC SECURITIES, INC.",
    city: "CITY OF MAKATI",
  },
  ILSTPHM1: {
    name: "CITIBANK SAVINGS INC",
    city: "CITY OF MANILA",
  },
  IMGAPHM1: {
    name: "IMPERIAL DE GUZMAN, ABALOS AND CO INC.",
    city: "CITY OF MAKATI",
  },
  INBLPHM1: {
    name: "MACQUARIE CAPITAL SECURITIES (PHILIPPINES) INC.",
    city: "CITY OF MANILA",
  },
  INGBPHMM: {
    name: "ING BANK N.V.",
    city: "CITY OF TAGUIG",
  },
  INIEPHM1: {
    name: "INTRA-INVEST SECURITIES INC",
    city: "CITY OF MAKATI",
  },
  INVUPHM1: {
    name: "INVESTORS SECURITIES INC",
    city: "CITY OF MAKATI",
  },
  IORUPHM1: {
    name: "INNOVATIVE BANK, INC.  (A RURAL BANK)",
    city: "CITY OF ANTIPOLO",
  },
  IREMPHM2: {
    name: "I-REMIT, INC.",
    city: "CITY OF PASIG",
  },
  ISTHPHM1: {
    name: "ISLA BANK (A THRIFT BANK), INC.",
    city: "CITY OF MAKATI",
  },
  ISVBPHM1: {
    name: "INSULAR SAVERS BANK, INC. (A RURAL BANK)",
    city: "CITY OF TAGUIG",
  },
  ITDEPHM2: {
    name: "INTER-ASIA DEVELOPMENT BANK",
    city: "CITY OF TAGAYTAY",
  },
  JARUPHM1: {
    name: "JANIUAY RURAL BANK, INC.",
    city: "CITY OF ILOILO",
  },
  KACUPHM2: {
    name: "KATIPUNAN BANKING CORPORATION 'A RURAL BANK'",
    city: "CITY OF DIPOLOG",
  },
  KARUPHM1: {
    name: "BANGKO KABAYAN (A RURAL BANK) INC.",
    city: "CITY OF BATANGAS",
  },
  KEYSPHM1: {
    name: "KEY SECURITIES INC",
    city: "CITY OF MANILA",
  },
  KMESPHM1: {
    name: "MAYBANK ATR KIM ENG SECURITIES, INC.",
    city: "CITY OF MAKATI",
  },
  KOEXPHMM: {
    name: "KEB HANA BANK",
    city: "CITY OF MAKATI",
  },
  KRBFPHM1: {
    name: "KATIPUNAN BANK (ZN), INC. A RURAL BANK",
    city: "CITY OF DIPOLOG",
  },
  LARCPHM1: {
    name: "LARRGO SECURITIES CO INC",
    city: "CITY OF MAKATI",
  },
  LAUIPHM2: {
    name: "SEABANK PHILIPPINES",
    city: "SANTA CRUZ",
  },
  LESIPHM1: {
    name: "LEGAZPI SAVINGS BANK",
    city: "City of Legazpi",
  },
  LFSHPHM2: {
    name: "LULU FINANCIAL SERVICES (PHILS) INC",
    city: "CITY OF TAGUIG",
  },
  LILOPHM1: {
    name: "RURAL BANK OF LILOY (ZN), INC",
    city: "CITY OF DIPOLOG",
  },
  LIMSPHM1: {
    name: "R.S. LIM AND CO. INC.",
    city: "CITY OF MANILA",
  },
  LIRAPHM2: {
    name: "LIFEBANK-A RURAL BANK",
    city: "CITY OF ILOILO",
  },
  LIRRPHM1: {
    name: "LIMCOMA RURAL BANK INC.",
    city: "CITY OF BATANGAS",
  },
  LIRUPHM1: {
    name: "LIPA BANK INC. -A RURAL BANK",
    city: "CITY OF LIPA",
  },
  LITSPHM1: {
    name: "LITONJUA SECURITIES INC",
    city: "CITY OF MANILA",
  },
  LOLLPHM1: {
    name: "LOPEZ, LOCSIN, LEDESMA AND CO INC",
    city: "CITY OF MAKATI",
  },
  LOLPPHM2: {
    name: "LOLC BANK PHILIPPINES INC",
    city: "CITY OF TANAUAN",
  },
  LPCRPHM2: {
    name: "LAGUNA PRESTIGE BANKING CORPORATION A RURAL BANK",
    city: "CITY OF CABUYAO",
  },
  LUCSPHM1: {
    name: "LUCKY SECURITIES INC",
    city: "CITY OF PASIG",
  },
  LUDVPHM1: {
    name: "LUZON DEVELOPMENT BANK",
    city: "CITY OF MANILA",
  },
  LURRPHM2: {
    name: "GM BANK OF LUZON, INC. (A RURAL BANK)",
    city: "CITY OF CABANATUAN",
  },
  LUYSPHM1: {
    name: "LUY'S SECURITIES CO INC",
    city: "CITY OF MANILA",
  },
  MAARPHM1: {
    name: "MALAYAN BANK SAVINGS AND MORTGAGE BANK",
    city: "CITY OF MAKATI",
  },
  MABCPHM1: {
    name: "MANILA BANKING CORP.",
    city: "CITY OF MAKATI",
  },
  MAIEPHM1: {
    name: "MARIAN SECURITIES INC",
    city: "CITY OF MAKATI",
  },
  MAKCPHM1: {
    name: "MARK SECURITIES CORP",
    city: "CITY OF MAKATI",
  },
  MANUPHM1: {
    name: "MANDARIN SECURITIES CORP",
    city: "CITY OF MANILA",
  },
  MAYCPHM2: {
    name: "MARCOPAY INC.",
    city: "CITY OF TAGUIG",
  },
  MBBEPHMM: {
    name: "MAYBANK PHILIPPINES, INC",
    city: "CITY OF MANILA",
  },
  MBTCPHMM: {
    name: "METROPOLITAN BANK AND TRUST CO.",
    city: "CITY OF MAKATI",
  },
  MCCEPHM1: {
    name: "METROBANK CARD CORPORATION (A FINANCE CO.)",
    city: "CITY OF MAKATI",
  },
  MCCTPHMM: {
    name: "MEGAWIDE CONSTRUCTION CORPORATION",
    city: "CITY OF QUEZON",
  },
  MCRUPHM1: {
    name: "1ST MACRO BANK, INC. (A RURAL BANK)",
    city: "CITY OF PATEROS",
  },
  MDRSPHM1: {
    name: "MDR SECURITIES, INC",
    city: "CITY OF MANILA",
  },
  MEOPPHM2: {
    name: "METRO SOUTH COOPERATIVE BANK",
    city: "CITY OF MAKATI",
  },
  MERTPHM1: {
    name: "MERIDIAN SECURITIES INC",
    city: "CITY OF PASIG",
  },
  MERUPHM1: {
    name: "MERCANTILE SECURITIES CORP",
    city: "CITY OF MAKATI",
  },
  MFCTPHMM: {
    name: "THE MANUFACTURERS LIFE INSURANCE CO. (PHILS.), INC.",
    city: "CITY OF MAKATI",
  },
  MGPSPHM1: {
    name: "DEUTSCHE REGIS PARTNERS, INC.",
    city: "CITY OF MAKATI",
  },
  MHCBPHMM: {
    name: "MIZUHO BANK, LTD., MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  MIMVPHM1: {
    name: "MICROFINANCE MAXIMUM SAVINGS BANK,INC.",
    city: "CITY OF CALAPAN",
  },
  MIOCPHM1: {
    name: "MINDANAO CONSOLIDATED COOPERATIVE BANK",
    city: "CITY OF CAGAYAN DE ORO",
  },
  MKDCPHM2: {
    name: "MAKILING DEVELOPMENT BANK CORPORATION",
    city: "CITY OF CALAMBA",
  },
  MKRUPHM1: {
    name: "BANK OF MAKATI (A SAVINGS BANK), INC.",
    city: "CITY OF MAKATI",
  },
  MLRUPHM2: {
    name: "MALARAYAT RURAL BANK, INC.",
    city: "CITY OF LIPA",
  },
  MLSPPHM1: {
    name: "MERRILL LYNCH SECURITIES PHILIPPINES INC.",
    city: "CITY OF MAKATI",
  },
  MOMLPHM2: {
    name: "MONEY MALL RURAL BANK, INC.",
    city: "CITY OF DAVAO",
  },
  MOPSPHM1: {
    name: "MOUNT PEAK SECURITIES INC",
    city: "CITY OF MANILA",
  },
  MOUAPHM2: {
    name: "BANGKO MONTANOSA, INC. A RURAL BANK",
    city: "CITY OF TABUK",
  },
  MRALPHMM: {
    name: "MANILA ELECTRIC COMPANY",
    city: "CITY OF PASIG",
  },
  MRLCPHM2: {
    name: "MACTAN RURAL BANK (LAPU-LAPU CITY) INC",
    city: "CITY OF LAPU-LAPU",
  },
  MRTCPHM1: {
    name: "BANGKO MABUHAY (A RURAL BANK), INC.",
    city: "CITY OF CAVITE",
  },
  MSLSPHM1: {
    name: "MERCHANTS SAVINGS AND LOAN ASSOCIATION, INC.",
    city: "CITY OF MAKATI",
  },
  MUIAPHM1: {
    name: "MULTINATIONAL INVESTMENT BANCORPORATION",
    city: "CITY OF MAKATI",
  },
  MURLPHM1: {
    name: "MUNICIPAL RURAL BANK OF LIBMANAN (CS), INC.",
    city: "CITY OF LIBMANAN",
  },
  MVRSPHM2: {
    name: "MVSM BANK (A RURAL BANK SINCE 1953)",
    city: "CITY OF MARIKINA",
  },
  MYYAPHM2: {
    name: "MAYA BANK, INC.",
    city: "CITY OF MANDALUYONG",
  },
  NESNPHMN: {
    name: "NESTLE BUSINESS SERVICES AOA INC",
    city: "CITY OF MEYCAUAYAN",
  },
  NEWCPHM1: {
    name: "NEW WORLD SECURITIES CO INC",
    city: "CITY OF MANILA",
  },
  NIESPHM1: {
    name: "NIEVES SANCHEZ INC.",
    city: "CITY OF MANILA",
  },
  NODVPHM1: {
    name: "NORTHPOINT DEVELOPMENT BANK, INC.",
    city: "CITY OF SAN PEDRO",
  },
  NRSLPHM1: {
    name: "NEW RURAL BANK OF SAN LEONARDO (NE) INC.",
    city: "CITY OF CABANATUAN",
  },
  NSPRPHM1: {
    name: "BANGKO NUESTRA SENORA DEL PILAR INC. (A RURAL BANK)",
    city: "CITY OF SAN SIMON",
  },
  NUBLPHM1: {
    name: "R. NUBLA SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  OMLFPHM1: {
    name: "ORIX METRO LEASING AND FINANCE CORPORATION",
    city: "CITY OF MAKATI",
  },
  OMNPPHM2: {
    name: "OMNIPAY, INC.",
    city: "CITY OF MAKATI",
  },
  ONNRPHM1: {
    name: "BDO NETWORK BANK, INC. (A RURAL BANK)",
    city: "CITY OF DAVAO",
  },
  ONSTPHM1: {
    name: "BANK ONE SAVINGS AND TRUST CORPORATION",
    city: "CITY OF MANILA",
  },
  OPDVPHM1: {
    name: "OPTIMUM DEVELOPEMENT BANK. INC",
    city: "CITY OF MANDALUYONG",
  },
  OPTMPHM1: {
    name: "OPTIMUM SECURITIES CORP.",
    city: "CITY OF PASIG",
  },
  ORIEPHM1: {
    name: "ORIENTRADE SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  ORMQPHM1: {
    name: "ORMON BANK RB OF MULANAY QUEZON INC.",
    city: "CITY OF SAN PABLO",
  },
  ORSIPHM1: {
    name: "BANCO DE ORO SAVINGS BANK, INC.",
    city: "CITY OF MAKATI",
  },
  OSPNPHM1: {
    name: "OCBC SECURITIES (PHILIPPINES) INC.",
    city: "CITY OF MANILA",
  },
  OUBKPHM1: {
    name: "OVERSEAS UNION BANK LIMITED, MANILA BRANCH",
    city: "CITY OF MANILA",
  },
  OWNOPHM2: {
    name: "OWN BANK THE RURAL BANK OF CAVITE CITY INC.",
    city: "CITY OF CAVITE",
  },
  PABIPHMM: {
    name: "BANK OF COMMERCE",
    city: "CITY OF MANDALUYONG",
  },
  PAEYPHM2: {
    name: "PAYMONGO PAYMENTS, INC.",
    city: "CITY OF TAGUIG",
  },
  PAHCPHM2: {
    name: "PAYNAMICS TECHNOLOGIES INC",
    city: "MAKATI CITY",
  },
  PANIPHM1: {
    name: "PAN ASIA SECURITIES CORPORATION",
    city: "CITY OF MANILA",
  },
  PAPDPHM1: {
    name: "THE PALAWAN BANK (PALAWAN DEVELOPMENT BANK, INC.).",
    city: "CITY OF PUERTO PRINCESA",
  },
  PAPHPHM1: {
    name: "PAYMAYA PHILIPPINES INC.",
    city: "CITY OF MANDALUYONG",
  },
  PAPSPHM1: {
    name: "PAPA SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  PASVPHM1: {
    name: "PACIFIC ACE SAVINGS BANK",
    city: "CITY OF OLONGAPO",
  },
  PATPPHM1: {
    name: "PACIFIC ASIAN ATLANTIC CAPITAL INC.",
    city: "CITY OF MAKATI",
  },
  PCBAPHM1: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF MANILA",
  },
  PCBAPHM10MB: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF MANILA",
    branch: "DASMARINAS BRANCH",
  },
  PCBAPHM10MC: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF CEBU",
    branch: "CEBU BRANCH",
  },
  PCBAPHM10MD: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF DAVAO",
    branch: "DAVAO BRANCH",
  },
  PCBAPHM10MP: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF MANILA",
    branch: "PORT AREA BRANCH",
  },
  PCBAPHM10MQ: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF QUEZON",
    branch: "CUBAO BRANCH",
  },
  PCBAPHM10MS: {
    name: "GLOBAL BUSINESS HOLDINGS INC.",
    city: "CITY OF SAN JUAN",
    branch: "ORTIGAS BRANCH",
  },
  PCHCPHM1: {
    name: "PHILIPPINE CLEARING HOUSE CORPORATION",
    city: "CITY OF MANILA",
  },
  PDAXPHM2: {
    name: "PHILIPPINE DIGITAL ASSET EXCHANGE, INC. (PDAX)",
    city: "CITY OF TAGUIG",
  },
  PDTCPHM1: {
    name: "PHILIPPINE DEPOSITORY AND TRUST CORPORATION",
    city: "CITY OF MAKATI",
  },
  PDTDPHM1: {
    name: "PHILIPPINE DEPOSITORY AND TRUST CORP. (DEPOSITORY)",
    city: "CITY OF MAKATI",
  },
  PDTUPHM1: {
    name: "PHILIPPINE DEPOSITORY AND TRUST CORP. (CUSTODY)",
    city: "CITY OF MAKATI",
  },
  PEPDPHM1: {
    name: "PENBANK A PRIVATE DEVELOPMENT BANK",
    city: "CITY OF GENERAL SANTOS",
  },
  PEQPPHM1: {
    name: "PHILIPPINE EQUITY PARTNERS INC.",
    city: "CITY OF MAKATI",
  },
  PESPPHM1: {
    name: "MAYBANK ATR KIM ENG SECURITIES, INC.",
    city: "CITY OF MAKATI",
  },
  PHCBPHMA: {
    name: "BANGKO SENTRAL NG PILIPINAS",
    city: "CITY OF MANILA",
  },
  PHCBPHMB: {
    name: "BANGKO SENTRAL NG PILIPINAS",
    city: "CITY OF MANILA",
  },
  PHCBPHMC: {
    name: "BANGKO SENTRAL NG PILIPINAS",
    city: "CITY OF MANILA",
  },
  PHCBPHMD: {
    name: "BANGKO SENTRAL NG PILIPINAS",
    city: "CITY OF MANILA",
  },
  PHCBPHMM: {
    name: "BANGKO SENTRAL NG PILIPINAS",
    city: "CITY OF MANILA",
  },
  PHCCPHM1: {
    name: "PHILIPPINE COMMERCIAL CAPITAL, INC.",
    city: "CITY OF MAKATI",
  },
  PHCDPHM1: {
    name: "PHILIPPINE DEPOSITORY AND TRUST CORP",
    city: "CITY OF MAKATI",
  },
  PHIIPHM1: {
    name: "ROBINSONS BANK CORPORATION",
    city: "CITY OF PASIG",
  },
  PHSAPHM1: {
    name: "EAST WEST BANKING CORPORATION",
    city: "CITY OF MANILA",
  },
  PHSBPHMM: {
    name: "PHILIPPINE SAVINGS BANK",
    city: "CITY OF MAKATI",
  },
  PHSVPHM1: {
    name: "OVERSEAS FILIPINO BANK, INC",
    city: "CITY OF MANILA",
  },
  PHTBPHMM: {
    name: "PHILTRUST BANK (PHILIPPINE TRUST COMPANY)",
    city: "CITY OF MANILA",
  },
  PHVBPHMM: {
    name: "PHILIPPINE VETERANS BANK",
    city: "CITY OF MAKATI",
  },
  PIEIPHM1: {
    name: "PIERCE INTERLINK SEC. INC.",
    city: "CITY OF MANILA",
  },
  PLAIPHM1: {
    name: "PLATINUM SECURITIES INC.",
    city: "CITY OF MAKATI",
  },
  PNBBPHM1: {
    name: "PNB SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  PNBMPHMM: {
    name: "PHILIPPINE NATIONAL BANK",
    city: "CITY OF MANILA",
  },
  PNBMPHMMTOD: {
    name: "PHILIPPINE NATIONAL BANK",
    city: "CITY OF PASIG",
    branch: "TREASURY OPERATIONS DIVISION",
  },
  PNSAPHM1: {
    name: "PNB SAVINGS BANK",
    city: "CITY OF MAKATI",
  },
  POUAPHM2: {
    name: "PROVIDENCE RURAL BANK INC.",
    city: "CITY OF TUGUEGARAO",
  },
  PPBUPHMM: {
    name: "PHILIPPINE BUSINESS BANK",
    city: "CITY OF CALOOCAN",
  },
  PPOSPHM1: {
    name: "PHILIPPINE POSTAL CORPORATION",
    city: "CITY OF MANILA",
  },
  PPSFPHM2: {
    name: "PPS-PEPP FINANCIAL SERVICES CORPORATION",
    city: "CITY OF PUERTO PRINCESA",
  },
  PRBPPH21: {
    name: "PRIME MEDIA HOLDINGS, INC.",
    city: "CITY OF CEBU",
  },
  PRBPPHM1: {
    name: "PRIME MEDIA HOLDINGS, INC.",
    city: "CITY OF MANILA",
  },
  PRDEPHM1: {
    name: "PREMIERE DEVELOPMENT BANK",
    city: "CITY OF MAKATI",
  },
  PREMPHM1: {
    name: "PREMIUM SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  PRNPPHM1: {
    name: "PLANBANK RURAL BANK OF CANLUBANG PLANTERS, INC.",
    city: "CITY OF CALAMBA",
  },
  PROTPHM1: {
    name: "PROBITY SECURITIES MANAGEMENT CORP.",
    city: "CITY OF MANILA",
  },
  PRTOPHM1: {
    name: "PARTNER RURAL BANK (COTABATO), INC.",
    city: "CITY OF KIDAPAWAN",
  },
  PSBOPHM1: {
    name: "PCCI SECURITIES BROKERS CORPORATION",
    city: "CITY OF MAKATI",
  },
  PSCOPHM1: {
    name: "PRODUCERS SAVINGS BANK CORPORATION",
    city: "CITY OF PASIG",
  },
  PUBLPHM1: {
    name: "SALISBURY BKT SECURITIES CORPORATION (FORMERLY: PUBLIC SECURITIES CORPORATION)",
    city: "CITY OF MAKATI",
  },
  QCDFPHM1: {
    name: "QUEEN CITY DEVELOPMENT BANK",
    city: "CITY OF ILOILO",
  },
  QCRIPHM1: {
    name: "QUEZON CAPITAL RURAL BANK, INCORPORATED",
    city: "CITY OF LUCENA",
  },
  QUISPHM1: {
    name: "QUALITY INVESTMENT AND SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  QWBSPHM2: {
    name: "QWIKWIRE BILLING SYSTEMS INC",
    city: "CITY OF MAKATI",
  },
  RARLPHM1: {
    name: "RANG-AY BANK (A RURAL BANK), INC.",
    city: "CITY OF SAN FERNANDO",
  },
  RBCYPHM1: {
    name: "RURAL BANK OF CAUAYAN INC.",
    city: "CITY OF CAUAYAN",
  },
  RBRUPHM2: {
    name: "RBT BANK, INC., A RURAL BANK",
    city: "CITY OF CAGAYAN DE ORO",
  },
  RCBCPH21: {
    name: "RIZAL COMMERCIAL BANKING CORPORATION",
    city: "CITY OF MAKATI",
    branch: "FOREIGN CURRENCY DEPOSIT UNIT - FCDU",
  },
  RCBCPHMM: {
    name: "RIZAL COMMERCIAL BANKING CORPORATION",
    city: "CITY OF MANILA",
  },
  RCCOPHM1: {
    name: "RCBC CAPITAL CORPORATION",
    city: "CITY OF MAKATI",
  },
  RCSAPHM1: {
    name: "RCBC SAVINGS BANK, INC.",
    city: "CITY OF MAKATI",
  },
  REGIPHM1: {
    name: "REGINA CAPITAL DEVELOPMENT CORP.",
    city: "CITY OF MANILA",
  },
  RETHPHM1: {
    name: "BDO UNIBANK, INC.",
    city: "CITY OF QUEZON",
  },
  RFCAPHM1: {
    name: "RFM CAPITAL LIMITED",
    city: "CITY OF MANILA",
  },
  RLSKPHM1: {
    name: "RURAL BANK OF LEBAK (SULTAN KUDARAT) INC.",
    city: "CITY OF TACURONG",
  },
  RLSUPHM2: {
    name: "RURAL BANK OF LANUZA (SURIGAO DEL SUR), INC.",
    city: "CITY OF BISLIG",
  },
  RNWAPHM1: {
    name: "RURAL BANK OF NEW WASHINGTON (AKLAN) INC.",
    city: "NEW WASHINGTON",
  },
  ROBPPHMQ: {
    name: "ROBINSONS BANK CORPORATION",
    city: "CITY OF QUEZON",
  },
  RPBAPHM1: {
    name: "MAYBANK PHILIPPINES, INC",
    city: "CITY OF MANILA",
  },
  RPBUPHM1: {
    name: "RURAL BANK OF PANDI (BULACAN), INC.",
    city: "PANDI",
  },
  RPMOPHM1: {
    name: "RURAL BANK OF PANA-ON (MIS. OCC.) INC.",
    city: "CITY OF OZAMIZ",
  },
  RSJCPHM1: {
    name: "RURAL BANK OF SAN JOSE (CAMARINES SUR), INC.",
    city: "CITY OF SAN ANTONIO",
  },
  RSLSPHM1: {
    name: "RURAL BANK OF SAN LUIS (BATANGAS),",
    city: "CITY OF ANGELES",
  },
  RSMCPHM2: {
    name: "RURAL BANK OF SANCHEZ MIRA CAGAYAN INC.",
    city: "CITY OF TUGUEGARAO",
  },
  RSMSPHM2: {
    name: "RURAL BANK OF SAN MATEO (ISABELA) INC",
    city: "CITY OF TUGUEGARAO",
  },
  RSNAPHM2: {
    name: "RURAL BANK OF SAN NARCISO, INC.",
    city: "ZAMBALES",
  },
  RTGCPHM1: {
    name: "RTG AND CO. INC.",
    city: "CITY OF MAKATI",
  },
  RUATPHM1: {
    name: "RURAL BANK OF ATIMONAN, INC.",
    city: "CITY OF QUEZON",
  },
  RUBCPHM2: {
    name: "RURAL BANK OF BACOLOD CITY, INC.",
    city: "CITY OF BACOLO",
  },
  RUBUPHM2: {
    name: "RURAL BANK OF BAUANG INC",
    city: "CITY OF SAN FERNANDO",
  },
  RUBYPHM2: {
    name: "RURAL BANK OF BAY, INC.",
    city: "CITY OF SAN PABLO",
  },
  RUCAPHM1: {
    name: "CAMALIG BANK INC. (A RURAL BANK)",
    city: "City of Legazpi",
  },
  RUDIPHM1: {
    name: "RURAL BANK OF DIGOS, INC",
    city: "CITY OF DIGOS",
  },
  RUGUPHM1: {
    name: "RURAL BANK OF GUINOBATAN, INC.",
    city: "GUINOBATAN",
  },
  RUHLPHM2: {
    name: "RURAL BANK OF HILONGOS (LEYTE), INC",
    city: "CITY OF TACLOBAN",
  },
  RUIEPHM2: {
    name: "RURAL BANK OF ITOGON (BENGUET), INC",
    city: "CITY OF BAGUIO",
  },
  RUJAPHM1: {
    name: "RURAL BANK OF JAEN, INC.",
    city: "CITY OF GAPAN",
  },
  RUKBPHM1: {
    name: "RURAL BANK OF KIBAWE (BUKIDNON),INC",
    city: "CITY OF VALENCIA",
  },
  RUKSPHM1: {
    name: "RURAL BANK OF KIAMBA (SARANGANI) INC.",
    city: "CITY OF KIAMBA",
  },
  RUMAPHM1: {
    name: "RURAL BANK OF MABALACAT, INC.",
    city: "CITY OF MABALACAT",
  },
  RUMDPHM1: {
    name: "RURAL BANK OF MIDSAYAP, INC.",
    city: "CITY OF KIDAPAWAN",
  },
  RUMIPHM1: {
    name: "RURAL BANK OF MIAGAO (ILOILO), INC.",
    city: "CITY OF ILOILO",
  },
  RUMNPHM1: {
    name: "RURAL BANK OF MANGALDAN, INC.",
    city: "CITY OF URDANETA",
  },
  RUMTPHM2: {
    name: "RURAL BANK OF MONTALBAN, INC.",
    city: "CITY OF ANTIPOLO",
  },
  RUODPHM1: {
    name: "MANOR BANK - A RURAL BANK CORP",
    city: "CITY OF BATANGAS",
  },
  RUPAPHM1: {
    name: "RURAL BANK OF PAGBILAO INC.",
    city: "CITY OF LUCENA",
  },
  RUPIPHM1: {
    name: "BANGKO RURAL NG PASACAO (CAMARINES SUR) INC",
    city: "PASACAO",
  },
  RUPPPHM2: {
    name: "RURAL BANK OF PORAC (PAMP), INC.",
    city: "CITY OF ANGELES",
  },
  RUPZPHM2: {
    name: "RURAL BANK OF LA PAZ, INC.",
    city: "CITY OF TARLAC",
  },
  RURLPHM2: {
    name: "BANKWAYS, INC. (A RURAL BANK)",
    city: "CITY OF CEBU",
  },
  RURUPHM2: {
    name: "RURAL BANK OF ROSARIO (LA UNION)INC",
    city: "CITY OF SAN FERNANDO",
  },
  RUSGPHM1: {
    name: "RURAL BANK OF STA. IGNACIA, INC.",
    city: "CITY OF TARLAC",
  },
  RUSNPHM2: {
    name: "RURAL BANK OF SOLANO (N.V.),INC.",
    city: "CITY OF SOLANO",
  },
  RUSTPHM2: {
    name: "RURAL BANK OF SILAY CITY, INC.",
    city: "SILAY CITY",
  },
  RUSYPHM2: {
    name: "RURAL BANK OF SAGAY, INC.",
    city: "CITY OF SAGAY",
  },
  RUTCPHM1: {
    name: "RURAL BANK OF TANGUB CITY INC.",
    city: "CITY OF TANGUB",
  },
  RUTNPHM1: {
    name: "RURAL BANK OF TANJAY, INC.",
    city: "CITY OF TANJAY",
  },
  SAPPPHM1: {
    name: "SAPPHIRE SECURITIES INC.",
    city: "CITY OF MAKATI",
  },
  SAUAPHM1: {
    name: "SAVIOUR RURAL BANK, INC.",
    city: "LUBAO",
  },
  SAVRPHM1: {
    name: "BANCO SAN VICENTE, INC. (A RURAL BANK)",
    city: "CITY OF PUERTO PRINCESA",
  },
  SCBLPHMM: {
    name: "STANDARD CHARTERED BANK",
    city: "CITY OF MAKATI",
  },
  SCBLPHMMEQI: {
    name: "STANDARD CHARTERED BANK",
    city: "CITY OF MAKATI",
    branch: "CUSTODIAL DEPARTMENT",
  },
  SECLPHM1: {
    name: "SECURITIES SPECIALISTS INC.",
    city: "CITY OF MANILA",
  },
  SECTPHM1: {
    name: "SAMSUNG ELECTRONICS PHILIPPINES CORP.",
    city: "CITY OF TAGUIG",
  },
  SECTPHM15B0: {
    name: "SAMSUNG ELECTRONICS PHILIPPINES CORP.",
    city: "CITY OF TAGUIG",
    branch: "SEPCO",
  },
  SECTPHM15B1: {
    name: "SAMSUNG ELECTRONICS PHILIPPINES CORP.",
    city: "CITY OF CALAMBA",
    branch: "SEPHIL",
  },
  SERTPHM1: {
    name: "G AND L SECURITIES CO., INC.",
    city: "CITY OF MANILA",
  },
  SETCPHMM: {
    name: "SECURITY BANK CORPORATION",
    city: "CITY OF MAKATI",
  },
  SEUUPHM1: {
    name: "A AND A SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  SGSEPHM1: {
    name: "SG SECURITIES (PHILIPPINES),INC.",
    city: "CITY OF MAKATI",
  },
  SHBKPHMM: {
    name: "SHINHAN BANK MANILA BRANCH",
    city: "CITY OF TAGUIG",
  },
  SHPHPHM2: {
    name: "SHOPEEPAY PHILIPPINES, INC.",
    city: "CITY OF TAGUIG",
  },
  SJROPHM1: {
    name: "S.J. ROXAS AND COMPANY, INC.",
    city: "CITY OF MANILA",
  },
  SMBCPHMM: {
    name: "SUMITOMO MITSUI BANKING CORPORATION MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  SOLRPHM1: {
    name: "SOLAR SECURITIES INC.",
    city: "CITY OF PASIG",
  },
  SOTTPHM1: {
    name: "SOUTH BANK INC",
    city: "CITY OF CAGAYAN DE ORO",
  },
  SPEYPHM2: {
    name: "SPEEDYPAY INC.",
    city: "CITY OF PASIG",
  },
  SRCPPHM2: {
    name: "STARPAY CORPORATION",
    city: "CITY OF PASIG",
  },
  SRLCPHM1: {
    name: "SUMMIT RURAL BANK OF LIPA CITY, INC",
    city: "CITY OF LIPA",
  },
  SSSTPHM1: {
    name: "SYSTEMS STANDARDS INC.",
    city: "CITY OF MAKATI",
  },
  STACPHM1: {
    name: "STANDARD SECURITIES CORPORATION",
    city: "CITY OF MANILA",
  },
  STIUPHM1: {
    name: "STATE INVESTMENT TRUST, INC.",
    city: "CITY OF MANDALUYONG",
  },
  STLAPH22: {
    name: "STERLING BANK OF ASIA INC.(A SAVINGS BANK)",
    city: "CITY OF SAN JUAN",
  },
  SUIRPHM1: {
    name: "SQUIRE SECURITIES, INC.",
    city: "CITY OF MANILA",
  },
  SUMMPHM1: {
    name: "SUMMIT SECURITIES INC.",
    city: "CITY OF PASIG",
  },
  SUPMPHM1: {
    name: "SUPREME STOCKBROKER INC.",
    city: "CITY OF MANILA",
  },
  SUSVPHM1: {
    name: "SUN SAVINGS BANK",
    city: "CITY OF TALISAY",
  },
  SWDEPHM1: {
    name: "UBS SECURITIES PHILIPPINES INC",
    city: "CITY OF MAKATI",
  },
  TACBPHMM: {
    name: "TAIWAN COOPERATIVE BANK MANILA OFFSHORE BANKING BRANCH",
    city: "CITY OF MANILA",
  },
  TAGCPHM2: {
    name: "TAGCASH LTD. INC.",
    city: "CITY OF MAKATI",
  },
  TANGPHM1: {
    name: "TANSENGCO AND COMPANY INC.",
    city: "CITY OF MANILA",
  },
  TANNPHM1: {
    name: "G.D. TAN AND CO INC",
    city: "CITY OF MAKATI",
  },
  TAYOPHM2: {
    name: "TAYOCASH INC.",
    city: "CITY OF PASIG",
  },
  TFSHPHM1: {
    name: "TOYOTA FINANCIAL SERVICES PHILIPPINES, CORP.",
    city: "CITY OF MAKATI",
  },
  TIOCPHM1: {
    name: "UY-TIOCO AND CO. INC.",
    city: "CITY OF MANILA",
  },
  TLBPPHM10M2: {
    name: "LAND BANK OF THE PHILIPPINES",
    city: "CITY OF DAVAO",
  },
  TLBPPHM10M3: {
    name: "LAND BANK OF THE PHILIPPINES",
    city: "CITY OF ILOILO",
  },
  TLBPPHM10M4: {
    name: "LAND BANK OF THE PHILIPPINES",
    city: "CITY OF GENERAL SANTOS",
  },
  TLBPPHM10MC: {
    name: "LAND BANK OF THE PHILIPPINES",
    city: "CITY OF CEBU",
  },
  TLBPPHM10MQ: {
    name: "LAND BANK OF THE PHILIPPINES",
    city: "CITY OF QUEZON",
  },
  TLBPPHMM: {
    name: "LAND BANK OF THE PHILIPPINES",
    city: "CITY OF MANILA",
  },
  TODGPHM2: {
    name: "TONIK DIGITAL BANK, INC.",
    city: "CITY OF PASIG",
  },
  TOKTPHM2: {
    name: "TOKTOKWALLET INC.",
    city: "CITY OF MAKATI",
  },
  TOPJPHM2: {
    name: "TOPJUAN TECH CORPORATION",
    city: "CITY OF MANILA",
  },
  TOWRPHM1: {
    name: "TOWER SECURITIES INC.",
    city: "CITY OF PASIG",
  },
  TRAAPHM1: {
    name: "TRANS-ASIA SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  TRBFPHM1: {
    name: "TRADERS ROYAL BANK",
    city: "CITY OF PASAY",
  },
  TRENPHM1: {
    name: "TRENDLINE SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  TRITPHM1: {
    name: "TRI-STATE SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  TRULPHM1: {
    name: "TIAONG RURAL BANK, INC.",
    city: "CITY OF TAYABAS",
  },
  TRXPPHM2: {
    name: "TRAXION PAY INC",
    city: "CITY OF PASIG",
  },
  TWENPHM1: {
    name: "DEUTSCHE REGIS PARTNERS INC.",
    city: "CITY OF MANILA",
  },
  TYBKPHMM: {
    name: "YUANTA SAVINGS BANK (FORMERLY TONGYANG SAVINGS BANK)",
    city: "CITY OF MANILA",
  },
  UBPHPHMM: {
    name: "UNION BANK OF THE PHILIPPINES",
    city: "CITY OF PASIG",
  },
  UBPPPHM1: {
    name: "UBP SECURITIES INC.",
    city: "CITY OF MAKATI",
  },
  UCSEPHM1: {
    name: "UNICAPITAL SECURITIES,INC.",
    city: "CITY OF MAKATI",
  },
  UCSVPHM1: {
    name: "UCPB SAVINGS BANK, INC.",
    city: "CITY OF MAKATI",
  },
  UKHCPHM1: {
    name: "UOB-KAY HIAN SECURITIES (PHILIPPINES), INC.",
    city: "CITY OF MAKATI",
  },
  UNOBPHM2: {
    name: "UNOBANK INC.",
    city: "CITY OF TAGUIG",
  },
  UNODPHM2: {
    name: "UNIONDIGITAL BANK INC.",
    city: "CITY OF PASIG",
  },
  UNRPPHMM: {
    name: "UNIVERSAL ROBINA CORPORATION",
    city: "CITY OF QUEZON",
  },
  UOVBPHMM: {
    name: "UNITED OVERSEAS BANK LIMITED - MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  USMEPHM2: {
    name: "USSC MONEY SERVICES INC",
    city: "CITY OF QUEZON",
  },
  UWCBPHMM: {
    name: "CATHAY UNITED BANK CO., LTD. MANILA BRANCH",
    city: "CITY OF MAKATI",
  },
  VADVPHM1: {
    name: "1ST VALLEY BANK INC., A DEVELOPMENT BANK",
    city: "CITY OF CAGAYAN DE ORO",
  },
  VENTPHM1: {
    name: "VENTURE SECURITIES INC.",
    city: "CITY OF MANILA",
  },
  VGBCPHM1: {
    name: "VIGAN BANCO RURAL INCORPORADA",
    city: "CITY OF VIGAN",
  },
  VICAPHM1: {
    name: "VICSAL SECURITIES AND STOCKS BROKERAGE INC",
    city: "CITY OF MANILA",
  },
  VICGPHM1: {
    name: "VICENTE GOQUIOLAY AND CO., INC.",
    city: "CITY OF MANILA",
  },
  WEASPHM1: {
    name: "WEALTH SECURITIES INC",
    city: "CITY OF MANILA",
  },
  WEDVPHM1: {
    name: "WEALTH DEVELOPMENT BANK",
    city: "CITY OF CEBU",
  },
  WERAPHM2: {
    name: "WELCOME BANK, RURAL BANK INC.",
    city: "CITY OF PASIG",
  },
  WICAPHM1: {
    name: "INDOSUEZ W.I. CARR SECURITIES (PHILIPPINES) INC.",
    city: "CITY OF MAKATI",
  },
  WISPPHM1: {
    name: "WORLDSEC INTERNATIONAL SECURITIES PHILIPPINES INC",
    city: "CITY OF MANILA",
  },
  WOLFPHM1: {
    name: "WOLFF AND CO. INC.",
    city: "CITY OF PASIG",
  },
  WONGPHM1: {
    name: "WONG SECURITIES CORP.",
    city: "CITY OF MANILA",
  },
  WOPAPHM1: {
    name: "WORLD PARTNERS BANK",
    city: "CITY OF SAN PEDRO",
  },
  XPHSPHM1: {
    name: "PHILIPPINE STOCK EXCHANGE, INC.",
    city: "CITY OF PASIG",
  },
  YAOZPHM1: {
    name: "YAO AND ZIALCITA INC.",
    city: "CITY OF MANILA",
  },
  YAPSPHM1: {
    name: "F. YAP SECURITIES INC",
    city: "CITY OF PASIG",
  },
  YAPTPHM1: {
    name: "YAPTINCHAY SEC. INC.",
    city: "CITY OF PASIG",
  },
  YUOYPHM1: {
    name: "YU AND COMPANY, INC.",
    city: "CITY OF PASIG",
  },
  ZACRPHM1: {
    name: "ZAMBOANGA CITY RURAL BANK, INC.",
    city: "CITY OF ZAMBOANGA",
  },
  ZARUPHM1: {
    name: "ZAMBALES RURAL BANK, INC.",
    city: "CITY OF OLONGAPO",
  },
  ZBTEPHM2: {
    name: "ZYBI TECH INC.",
    city: "CITY OF PASAY",
  },
} as const satisfies Record<string, Omit<BankInfo, "swiftCode">>;

export type SwiftCode = keyof typeof bankCodesBySwiftCode;
